import { IStore } from '../index'

export default function(state: IStore) {
  return state.invoice
}

export function getInvoiceReservationId(state: IStore) {
  return state.invoice.reservationId
}

export function getInvoiceLoading(state: IStore) {
  return state.invoice.loading || false
}
